import store from '@/store';

export default class RPIController {
  static init() {
    if (window.io && !window.rpi) {
      const rpi = io('http://127.0.0.1:4000/');
      window.rpi = rpi;
      this.setListener(rpi);
    } else {
      window.rpi = undefined;
    }
  }

  static setListener(socket) {
    socket.on('connect', () => {
      console.log('hi');
      store.dispatch('notification/new', {
        title: 'Hi Pi',
      });
    });

    socket.on('disconnect', () => {
      console.log('bye');
      store.dispatch('notification/new', {
        title: 'Bye Pi',
      });
    });

    socket.on('response', (message) => {
      console.log(message);
      store.dispatch('notification/new', {
        title: 'Response Pi',
        message,
      });
    });
  }

  static emit(command, options = {}, id = '1001') {
    window.rpi.emit('request', {
      tdi: id,
      apiCommand: command,
      options,
    });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/RPIController.js